import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {supplierSuggestionsUrl} from "~/pages/supplier-360/services/supplier360PdlUrls";
import type {SupplierSuggestion} from "~/pages/supplier-360/types/Supplier360PdlTypes";

/** Open domain/alias suggestions for one entity — a handful at most, well under one page. */
export function useSupplierSuggestionsQuery(entityId: number | undefined) {
    const url = supplierSuggestionsUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<SupplierSuggestion>>(url)).data.results,
        enabled: Boolean(entityId),
    });
}
